module.exports = __webpack_public_path__ + "img/Slider_montagne_mobile-EJ.74ca6bf6.png";